
import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  onMounted,
  computed,
  watch,
  nextTick
} from 'vue'
import dataLoad from './dataLoad.vue'
import Charts from '@/components/page/charts.vue'
import { useRoute } from 'vue-router'
import f10Api from '@/api/f10Api'

export default defineComponent({
  components: { dataLoad, Charts },
  props: {
    token: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      spinning: true,
      option: {}
    })
    const route = useRoute()
    watch(
      () => (props as any).token,
      (val) => {
        if (val) {
          getBaseIndexF10IndustryWeight()
        }
      },
      { deep: true, immediate: true }
    )

    // 获取行业权重
    function getBaseIndexF10IndustryWeight() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: (props as any).token
      }
      f10Api
        .baseIndexF10IndustryWeight(data)
        .then((res: any) => {
          if (res.Code === 0) {
            setChart(res.Data.List)
            context.emit('chageTime', {
              index: 2,
              time: res.Data.EndDate
            })
          }
          pageData.spinning = false
        })
    }

    function setChart(list) {
      pageData.option = {
        color: [
          '#0060FF',
          '#FF9300',
          '#00D894',
          '#FF469D',
          '#00E1FF',
          '#CD00C1',
          '#7E98BF',
          '#FA5949',
          '#FFC900',
          '#5807DE'
        ],
        tooltip: {
          trigger: 'item',
          position: 'right',
          formatter: function (params: any) {
            const { data, color } = params
            // '{b}<br /> <i style="width: 10px;height: 10px;border-radius: 50%;"></i>比例： {d}%'
            return `<div style="font-size: 12px"><p>${
              data.name
            }</p><div style="width: 10px;height: 10px;border-radius: 50%;display:inline-block;background-color: ${color}"></div> 比例： ${data.value.toFixed(
              2
            )}%</div>`
          }
        },
        legend: {
          top: 'middle',
          right: '25%',
          orient: 'vertical',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          textStyle: { color: '#fff' },
          itemGap: 15
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            center: ['40%', '50%'],
            data: list.map((v) => {
              return {
                name: v.Industry,
                value: v.WeightRatio * 100
              }
            }),
            labelLine: {
              show: false
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }

    return {
      ...toRefs(pageData)
    }
  }
})
